import React, { useCallback, useEffect, useState } from "react";
import ResumoIcon from "@mui/icons-material/FeedOutlined";
import KpisEstruturaisIcon from "@mui/icons-material/TrendingUpOutlined";
import VendaExcelenteIcon from "@mui/icons-material/StorefrontOutlined";
import RankingIcon from "@mui/icons-material/MilitaryTechOutlined";
import StorefrontOutlinedIcon from "@mui/icons-material/LocalOfferOutlined";
import { Box, Grid } from "@mui/material";
import PropTypes from "prop-types";
import { useLeftBar } from "../../context/LeftBar";
import { Header } from "./components/Header";
import NavItem from "./MenuItem/NavItem";
import KpisPerformanceIcon from "@mui/icons-material/SpeedOutlined";
import FormulaLogoFooter from "../../assets/img/logo-footer-excellence.png";
import ArrowBackIosOutlinedIcon from "@mui/icons-material/ArrowBackIosOutlined";
import ArrowForwardIosOutlinedIcon from "@mui/icons-material/ArrowForwardIosOutlined";
import { ReactComponent as QuestionBoxIcon } from "../../assets/icons/question-box.svg";
import { ReactComponent as RolesIcon } from "../../assets/icons/articles-outlined.svg";

function LeftSideMenu({ app, config, logo }) {
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  const [dataAtualizacao, setDataAtualizacao] = useState("");
  const [showRanking, setShowRanking] = useState();

  const validateShowRanking = useCallback(
    async (objectId) => {
      if (app && objectId) {
        let id = objectId;
        await app.visualization.get(id).then((res) => {
          const value =
            res?.model?.layout?.qHyperCube?.qGrandTotalRow[0]?.qText ??
            res?.model?.layout?.qHyperCube?.qGrandTotalRow[0]?.qNum ??
            null;

          setShowRanking(value);
        });
      }
    },
    [app]
  );

  async function initialSelecao() {
    await app.variable.getContent("vAtualizacao", (reply) => {
      const data = reply.qContent.qString;
      setDataAtualizacao(data.substring(0, 15));
    });
  }

  useEffect(() => {
    initialSelecao();
    window.addEventListener("resize", () => setScreenWidth(window.innerWidth));
    validateShowRanking("RMHbJk");

    return () => {
      window.removeEventListener("resize", () =>
        setScreenWidth(window.innerWidth)
      );
    };
  }, []);

  const { leftBarOpened, setLeftBarOpened } = useLeftBar();

  return (
    <div className={leftBarOpened ? "leftSideMenu is-opened" : "leftSideMenu"}>
      <div className="containerLeftSideMenu">
        <Header leftBarOpened={leftBarOpened} />

        <div className="leftSideClientContainer">
          {leftBarOpened && (
            <h2 className="titleSideCLient">Programa de Excelência</h2>
          )}
        </div>

        <div
          className={
            leftBarOpened
              ? "leftSideContent"
              : "leftSideContent leftSideContent-open"
          }
        >
          <ul>
            <NavItem muiIcon={<ResumoIcon />} name="Resumo" path="/resumo" />

            <NavItem
              muiIcon={<KpisEstruturaisIcon />}
              name="KPIs Estruturais"
              path="/estruturais"
            />

            <NavItem
              muiIcon={<KpisPerformanceIcon />}
              name="KPIs de Performance"
              path="/performance"
            />

            <NavItem
              muiIcon={<VendaExcelenteIcon />}
              name="Venda Excelente"
              path="/excelente"
            />

            {showRanking === "1" && (
              <NavItem
                muiIcon={<RankingIcon />}
                name="Ranking"
                path="/ranking"
              />
            )}

            {/* <NavItem
              muiIcon={<StorefrontOutlinedIcon />}
              name="Alertas"
              path="/alertas"
            /> */}
          </ul>
        </div>

        <div
          className={
            leftBarOpened
              ? "leftSideContent leftSideContent-second"
              : "leftSideContent leftSideContent-second leftSideContent-open"
          }
        >
          <h3 className="titleHelp">AJUDA</h3>
          <ul>
            <NavItem
              muiIcon={<RolesIcon />}
              name="Regras da campanha"
              path="/regras"
            />

            <NavItem
              muiIcon={<QuestionBoxIcon />}
              name="Perguntas Frequentes"
              path="/faq"
            />
          </ul>
        </div>

        {leftBarOpened && (
          <Grid
            flexDirection={"column"}
            alignItems={"flex-start"}
            columnGap={1}
            className="leftSideFooter"
          >
            <Grid item>
              <Box
                component={"img"}
                src={FormulaLogoFooter}
                className="container-img-leftSide"
              />
            </Grid>
            <Grid item>
              <span>Atualizado em: {dataAtualizacao} </span>
            </Grid>
          </Grid>
        )}
      </div>

      <div className="containerCloseSideMenu">
        <button
          type="button"
          onClick={() => {
            setLeftBarOpened(!leftBarOpened);
          }}
          className={leftBarOpened ? "" : "align-left"}
        >
          {leftBarOpened ? (
            <ArrowBackIosOutlinedIcon
              fontSize="small"
              sx={{ color: "#04477B" }}
            />
          ) : (
            <ArrowForwardIosOutlinedIcon
              fontSize="small"
              sx={{ color: "#04477B" }}
            />
          )}
        </button>
      </div>
    </div>
  );
}

LeftSideMenu.defaultProps = {
  app: null,
  config: null,
  logo: null,
};

LeftSideMenu.propTypes = {
  app: PropTypes.object,
  config: PropTypes.object,
  logo: PropTypes.object,
};

export default LeftSideMenu;
